import React from "react";
import {Stack, Typography, Skeleton} from "@mui/material";
import {ColletteDivider} from "@collette-travel/collette-common-controls";
import {ColletteTourOverviewHeaderSkeletonProps} from "../types";
import InfoIcon from "../info-icon";

const KeyTourInfoSkeletonColumn = ({
  testId,
  details,
  labelColor = "primary",
  showDividers = true,
  infoIconVariant = "outlined",
  sxOverride = {}
}: ColletteTourOverviewHeaderSkeletonProps) => (
  <Stack
    sx={{
      flexDirection: "column",
      display: "flex",
      gap: "0.8rem",
      width: "100%",
      justifyContent: "space-between",
      ...sxOverride
    }}
    data-testid={`${testId}_tour-overview-header-skeleton`}
  >
    {details.map((detail, index) => (
      <Stack
        direction="column"
        gap="0.8rem"
        key={detail.id}
      >
        <Stack
          sx={{
            gap: "1.2rem",
            flexDirection: "row",
            justifyContent: "space-between",
            alignItems: "center"
          }}
          data-testid={`${testId}_tour-overview-header-skeleton_${detail.id}_cell`}
        >
          <Stack
            sx={{
              flexDirection: "row",
              alignItems: "center",
              gap: "0.4rem"
            }}
            data-testid={`${testId}_tour-overview-header-skeleton_${detail.id}_label-container`}
          >
          <Typography
            color={labelColor}
            sx={{
              textTransform: "uppercase",
              fontSize: "1.6rem",
              fontWeight: 700,
              lineHeight: "150%",
              textWrap: "nowrap"
            }}
            data-testid={`${testId}_tour-overview-header-skeleton_${detail.id}_label`}
          >
            {detail.label ?? <Skeleton width="10rem" />}
          </Typography>
            {detail.showInfoIcon && detail.label && (
              <InfoIcon
                variant={infoIconVariant}
                color={labelColor === "primary" || labelColor === "secondary" ? labelColor : undefined}
                sx={{
                  height: "2rem",
                  width: "2rem",
                  color: labelColor === "text.disabled" ? "text.disabled" : undefined,
                  mb: "0.2rem"
                }}
              />
            )}
          </Stack>
          <Skeleton width="10rem" data-testid={`${testId}_tour-overview-header-skeleton_${detail.id}_value`} />
        </Stack>
        {showDividers && index !== details.length - 1 && (
          <ColletteDivider
            orientation="horizontal"
            sx={{ borderColor: "divider" }}
          />
        )}
      </Stack>
    ))}
  </Stack>
);

export default KeyTourInfoSkeletonColumn;